export enum AuthedRoutesEnum {
  Profile = '/profile',
  Obligations = '/obligations',
  Reports = '/reports',
  Goods = '/goods',
  Company = '/company',
  CompanyContact = '/company/contact',
  DataFiles = '/data-files',
  VAT = '/vat',
  SetupOverview = '/setup-overview',
  CountryDetails = '/country-details/:id',
  Inventory = '/inventory',
  Services = '/services',
  Sales = '/sales',
  InvoiceBook = '/invoice-book',
  Documents = '/documents',
  Recommendations = '/recommendations',
  AmazonFees = '/amazon-fees',
  Filing = '/filing',
  PurchasePrices = '/purchase-prices',
  DatevOverview = '/datev-transactions/:year/:month',
  OSSFiles = '/oss-files',
  DATEVConfiguration = '/datev-configuration',
  Proforma = '/pro-forma',
  Datev = '/datev',
  ChartOfAccounts = '/chart-of-accounts',
  COADebtor = '/chart-of-accounts/debtor',
  COARevenue = '/chart-of-accounts/revenue',
  COACountries = '/chart-of-accounts/countries',
  COAShipments = '/chart-of-accounts/shipments',
  COAExpenses = '/chart-of-accounts/expenses',
  COAOther = '/chart-of-accounts/other',
  OSSReportsInfo = '/oss-reports-info',
  OSSReport = '/report/:id',
  OSSInstruction = '/oss-instruction',
  ReclaimVATInstruction = '/reclaim-vat-instruction',
  ClientOSS = '/clients/:id/oss',
  ClientDATEV = '/clients/:id/datev',
  SetupCheck = '/setup-check',
  ProformaInvoices = '/proforma-invoices',
  NewProcessesInstructions = '/data-files/how-to-work',
  TinNumberInformation = '/vat/tin-number',
  JtlInstruction = '/jtl-instruction',
  Integrations = '/integrations',
  VatRates = '/vat-rates',
  Resources = '/resources',
  ICSales = '/ic-sales',
  Expenses = '/expenses',
  ExpensesDistribution = '/expenses/distribution',
  Insights = '/insights',
  Billing = '/billing',
  AmazonVCSInstruction = '/amazon-vcs-instruction',
  AmazonConnexInstruction = '/amazon-connex-instruction',
}

export enum PublicRoutesEnum {
  RegisterCustomer = '/register-customer',
  RegisterTaxAdvisor = '/register-advisor',
  RegisterOSS = '/register-oss',
  RegisterAmazonConnex = '/register-amazon-connex',
  RegisterTaxAdvisorWithInvitation = '/register-tax-advisor',
  Register = '/register',
  Page404 = '/404',
  TermsOfService = '/terms-of-service',
  DataProcessingAgreement = '/data-processing-agreement',
  ForgotPassword = '/forgot-password',
  CreatePassword = '/create-password',
}

export enum RolesEnum {
  SELLER = 'SELLER',
  AGGREGATOR = 'AGGREGATOR', // depracated
  TAX_ADVISOR = 'TAX_ADVISOR',
  SETUP_CHECK = 'SETUP_CHECK',
  OSS = 'OSS',
  AMAZON_CONNEX_SELLER = 'AMAZON_CONNEX_SELLER',
  JTL_TAX_SETTINGS_CHECK = 'JTL_TAX_SETTINGS_CHECK',
}

export enum ClientTaxDetailsStatusEnum {
  WAITING = 'waiting',
  NEW = 'new',
  CHECK = 'check',
  CHECK_DONE = 'check_done',
  DOCS_PREP = 'docs_prep',
  DOCS_READY = 'docs_ready',
  SENT_TO_CLIENT = 'sent_to_client',
  SENT_RECEIVED = 'received',
  TO_TAX_OFFICE = 'to_tax_office',
  IN_TAX_OFFICE = 'in_tax_office',
  TAX_ID_RECEIVED = 'tax_id_received',
  VAT_ID_RECEIVED = 'vat_id_received',
  REGISTERED = 'registered',
  STOPPED = 'stopped',
  PAUSED = 'paused',
  NOT_NEEDED = 'not_needed',
  DEREGISTERED = 'deregistered',
}

export enum SellerFilingReportStatusEnum {
  New = 'new',
  ToDo = 'todo',
  Blocked = 'blocked',
  InProgress = 'in_progress',
  Prepared = 'prepared',
  SentToAdvisor = 'sent_to_advisor',
  InstructionSent = 'instruction_sent',
  ConfirmationSent = 'confirmation_sent',
  Paid = 'paid',
  Submitted = 'submitted',
}

export enum TaxCollectionResponsibilityEnum {
  Seller,
  Marketplace,
}
export enum ImportTaxResponsibilityEnum {
  Seller,
  'End-customer',
}
export enum ManualUploadFileStatusEnum {
  CREATED,
  IMPORTING,
  READY,
  VALIDATED,
}

export enum FileStatusEnum {
  CREATED = 0,
  IMPORTED,
  FAILED,
}

export enum PurchasePriceErrorCode {
  INVALID_MIME_TYPE = 1,
  EMPTY_PRICE = 2,
  INVALID_COLUMNS_NUMBER = 3,
  EMPTY_SKU = 4,
  INVALID_VAT_RATE = 5,
  INVALID_HEADERS = 6,
  INVALID_CN_CODE = 7,
}
export enum IdNumberStatusEnum {
  Requested = 2,
  Active = 1,
  Unavailable = 4,
  Deactivated = 8,
}
export enum EvaluatiionStatusEnum {
  Requested = 1,
  Generating,
  Done,
  Error,
}

export enum ToastType {
  'evaluation' = 'evaluation',
  'proformaZip' = 'proformaZip',
  'correctionErrorsExport' = 'correctionErrorsExport',
}

export enum ManualUploadFilesWorkStatusEnum {
  'New',
  'Preparation',
  'Finished',
  'On client',
  'Discarded',
  'Correction uploaded',
}

export enum JTLCredentialsStatusEnum {
  ConnectionNotEstablished = 'connection_not_established',
  ConnectionEstablished = 'connection_established',
  ConnectionWithoutFiling = 'connection_without_filing',
  ConnectionLost = 'connection_lost',
  WaitingForSync = 'waiting_for_sync',
}

export enum DUItemStatusEnum {
  NEW = 0,
  PREPARATION,
  FINISHED,
  ON_CLIENT,
  DATA_UPLOADED,
  SUBMIT_MISSING_DATA,
  SUBMIT_UNCORRECTED_DATA,
  ATTENTION,
}

export enum CorrectionType {
  Correction = 'correction',
  Addition = 'addition',
  Report = 'report',
}

export enum PricingModelEnum {
  Old = 'old',
  Core = 'core',
  Professional = 'professional',
  JTLIncludingOSSSeSe = 'jtl_including_oss_sese',
}

export enum InvoiceDocumentErrorSeverityEnum {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  NOTICE = 'NOTICE',
}

export enum DataCorrectionStatusEnum {
  Allowed = 'allowed',
  Blocked = 'blocked',
}

export enum InvoiceDocumentCorrectionStatusEnum {
  Init = 'init',
  Corrected = 'corrected',
  ToBeCorrected = 'to_be_corrected',
  Blocked = 'blocked',
}

export enum PlaceToUploadEnum {
  Main = 'main',
  ToDo = 'todo',
}

export enum ReportSubTypesEnum {
  ICSales = 'ic_sale',
  VATReport = 'vat_report',
}
export enum ChartOfAccountsTypeEnum {
  'SKR03' = 'SKR03',
  'SKR04' = 'SKR04',
}
export enum DatevFileStandardEnum {
  'ascii' = 'ascii',
  'extf' = 'extf',
  'enriched' = 'enriched',
}

export enum ReportResultStatusEnum {
  STATUS_READY = 1,
  STATUS_REQUESTED,
  STATUS_ERROR,
  STATUS_STARTED,
}

export enum ReportResultErrorCodeEnum {
  ENTITY_NOT_FOUND = 'entity_not_found',
  MISSING_VAT_ID = 'missing_vat_id',
  NO_DATA = 'no_data',
  TIMEOUT = 'timeout',
  UNKNOWN = 'unknown',
}

export enum DatevEntryTypesEnum {
  datev_trns = 6,
  datev_shipment = 7,
  datev_commingling = 8,
  datev_trns_local = 10,
  datev_trns_gross = 21,
  datev_trns_netto = 11,
  datev_trns_vat = 12,
  datev_shipment_taxable = 19,
  datev_settlement = 22,
}

export enum DatevOptionsEnum {
  datev_trns = 'datev_trns',
  datev_shipment = 'datev_shipment',
  datev_commingling = 'datev_commingling',
  datev_trns_local = 'datev_trns_local',
  datev_trns_netto = 'datev_trns_netto',
  datev_trns_vat = 'datev_trns_vat',
  datev_trns_gross = 'datev_trns_gross',
  datev_shipment_taxable = 'datev_shipment_taxable',
  datev_settlement = 'datev_settlement',
}

export enum ProformaInvoiceStatusEnum {
  NORMAL,
  IGNORED,
}

export enum WorkflowTaskTypeEnum {
  STATUS = 'status',
  TODO = 'todo',
  GROUPED_TODO = 'grouped_todo',
  DONE = 'done',
}

export const MODAL_MODE = {
  NPS: 'nps',
  CES: 'ces',
} as const;

export enum SourceConnectionStatusEnum {
  NO_CONNECTION = 'no_connection',
  LOST_CONNECTION = 'lost_connection',
  CONNECTED = 'connected',
}

export enum PricesFilterEnum {
  ALL = 'all',
  MISSING = 'only_missing_prices',
  AVAILABLE = 'only_valid_prices',
}

export enum SettlementReportsTypesEnum {
  settlement_income = 53,
  settlement_payout = 59,
  settlement_amazon_sales_fees = 61,
  settlement_fba_warehouse_fees = 62,
  settlement_amazon_service_fees = 63,
  settlement_advertising_fees = 64,
  settlement_other_costs = 65,
  settlement_vat_amazon_fees = 66,
  settlement_vat_third_party_countries = 67,
  settlement_reserve_clearing = 68,
  settlement_reimbursment_clearing = 69,
}
